// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Carousel_arrow__CFCty","caption":"Carousel_caption__eLa9A","controls":"Carousel_controls__2jKbd","img":"Carousel_img__6keUF","imgDiv":"Carousel_imgDiv__1rlL-"};